abcsetup.promos = abcsetup.promos || {};
abcsetup.promos.plans = abcsetup.promos.plans || {};
abcsetup.promos.plans.create = abcsetup.promos.plans.create || {};

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promos.plans.create = {
    init: () =>
    {
        $('[data-toggle="tooltip"]').tooltip();

        abcsetup.promos.plans.create.initListeners();
        abcsetup.promos.plans.create.renderPlan();
    },
    initListeners: () => {
        // Track changes to input fields for each promo plan promo
        $(document).on('change', '.promo-op, .perc-allocated, .unit_cost_override, input[type="number"], input[type="text"], select', function() {
            let promoId = $(this).closest('.promo_plan_accordion').data('promo_id');
            $('input[name="promo_plan_promo['+promoId+'][is_modified]"]').val('1');
        });

        // Submit button clicked

        // Validate tab button clicked
        $("button[value='validate']").on("click", function () {
            // Open all collapsables
            $('.planned_promo_container').find('div[data-toggle="collapse"]').each(function () {
                console.log("collapse");
                if(!$($(this).data('target')).hasClass('show')){
                    console.log("collapse click");
                    $(this).trigger('click');
                }
            });
            abcsetup.promos.plans.create._validateForm();
            return false;
        });

        $("button[value='submit']").on("click", function () {
            // Open all collapsables
            $('.planned_promo_container').find('div[data-toggle="collapse"]').each(function () {
                console.log("collapse");
                if(!$($(this).data('target')).hasClass('show')){
                    console.log("collapse click");
                    $(this).trigger('click');
                }
            });

            abcsetup.promos.plans.create.calculateTotalPromoPlanCost();
            return !!abcsetup.promos.plans.create._validateForm();
        });

        $("button[value='save']").on("click", function () {
            abcsetup.promos.plans.create.calculateTotalPromoPlanCost();
            return true;
        });

        $(document).on('click', '.promo_type_promo', function() {
            if (abcsetup.userRole.class != 'promo_team') {
                $('.promo_loader').show();
                $('.no_selected_promos').hide();
                const params = {
                    vendor: $('#vendor').val(),
                    fiscal_year: $('#fiscal_year').val()
                };
                axios.post('/api/promos/plans/' + $(this).data('promo_id') + '/add', params)
                    .then((response) => {
                        $('.promo_loader').hide();
                        if (response.data.error){
                            abcsetup.alerts.flashMessage(response.data.error,'warning');
                            // abcsetup.alerts.error();
                            return false;
                        }
                        $('.planned_promo_container .items').html(response.data);
                        $('[data-toggle="tooltip"]').tooltip();
                    });
            }
        });
        $(document).on('click', 'div[data-toggle="collapse"]', function() {
            abcsetup.promos.plans.create.calculatePromoPlanCategoryBudgets($(this).closest('.promo_plan_accordion'));
        });

        $(document).on('click', '.remove-promo', function() {
            $('.promo_loader').show();
            axios.get('/api/promo_plans/promo/' + $(this).data('id') +'/remove')
                .then((response) => {
                    $('.promo_loader').hide();
                    $('.planned_promo_container .items').html(response.data);
                    if(!response.data) {
                        $('.no_selected_promos').show();
                        $('[data-toggle="tooltip"]').tooltip();
                    }
                    $('#btn-submit').prop('disabled',false);
                });
        });

        $(document).on('change', '.promo-op', function() {
            abcsetup.promos.plans.create.calculateTotalPromoPlanCost();
            abcsetup.promos.plans.create.calculatePromoPlanCategoryBudgets($(this).closest('.promo_plan_accordion'));
        });

        $(document).on('change',':input', function() {
            $('#btn-submit').prop('disabled',false);
        });

        $(document).on('change', '.perc-allocated', function() {
            const $percent_allocated_inputs = $(this).closest('.promo_category_select').find('.perc-allocated');
            let total_percent_allocated = 0;
            $percent_allocated_inputs.each(function() {
                if ($(this).val()){
                    let allocation = parseFloat($(this).val());
                    total_percent_allocated += allocation;
                }
            });

            let percent_unallocated = 100 - total_percent_allocated;
            $(this).closest('.promo_category_select_container').find('.perc_unallocated').html(percent_unallocated.toFixed(2));

            // if(total_percent_allocated > 100) {
            //     $(this).addClass('is-invalid');
            //     $(this).focus();
            //     $(this).closest('.input-group').find('.error').html('Total category spend is larger than 100%');
            // } else {
            //     $(this).removeClass('is-invalid');
            //     $(this).closest('.input-group').find('.error').html('');
            // }
            abcsetup.promos.plans.create.calculatePromoPlanCategoryBudgets($(this).closest('.promo_plan_accordion'));
        });
    },
    renderPlan: () => {
        $('.promo_loader').show();
        axios.get('/api/promo_plans/plans/edit?fiscal_year=' + $('#fiscal_year').val() + '&vendor=' + $('#vendor').val())
            .then((response) => {
                $('.promo_loader').hide();
                $('.no_selected_promos').hide();
                $('.planned_promo_container .items').append(response.data);
                $('[data-toggle="tooltip"]').tooltip();
            });
    },

    calculateTotalPromoPlanCost: () => {

        let total_promo_plan_cost = 0;
        let cost_per = 0;
        let cost_qty = 0;
        $('.planned_promo_container').find('.items > div').each( function() {
            let cost_sum = 0;
            let cost_override = 0;
            let promo_id = $(this).data('promo_id');
            $(this).find('.planned_promo_input_fields_container').find('input.promo-op').each(function() {
                cost_per = $(this).data('cost') * 1.0;
                cost_qty = $(this).val() * 1.0;
                cost_override = $(this).closest('tr').find('.unit_cost_override').val();

                if(cost_override.length > 0) {
                    cost_sum += parseFloat(cost_override) * cost_qty;
                } else if (cost_per && cost_qty) {
                    cost_sum += (cost_per) * (cost_qty);
                }
            });

            $(this).find('.card-header').find('.planned-cost').html(cost_sum.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}));
            $(this).find('#planned_cost_' + promo_id).val(cost_sum);

            total_promo_plan_cost += cost_sum;

        });

        $('#promo-plan-cost').html(total_promo_plan_cost.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}));
        $('#total_budget').val(total_promo_plan_cost);

        let prev_promo_plan_cost = parseFloat($('#prev-promo-plan-cost').text().replace(/,/,''));
        // console.log('Current Promo Budget: ' + total_promo_plan_cost);
        // console.log('Prev Promo Budget: ' + prev_promo_plan_cost);
        const diff = total_promo_plan_cost - prev_promo_plan_cost;
        // console.log('Diff: ' + diff);
        if(diff < 0) {
            $('.budget_difference').removeClass('up').addClass('down').html('<i class="fas fa-arrow-down"></i>');
        } else if (diff === 0) {
            $('.budget_difference').removeClass('up down').html('');
        } else {
            $('.budget_difference').removeClass('down').addClass('up').html('<i class="fas fa-arrow-up"></i>');
        }
        $('#promo-plan-cost-budget-diff').html(diff.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}));
    },

    calculatePromoPlanCategoryBudgets: (container) => {

        var planned_cost = container.find("input.planned_cost").val();
        var total_percentage = 0 ;

        container.find("[name*=perc_budget]").each(function() {
            var perc_budget = $(this).val()/100;
            //console_log('perc_budget->'+perc_budget+' planned_cost '+planned_cost);
            var _this = $(this);
            if(perc_budget) {
                var perc_budget_dollar_value = planned_cost*perc_budget ;
                _this.closest(".category-data").find(".perc_budget_dollar_value").html(abcsetup.accounting.formatMoney(perc_budget_dollar_value));
            } else {
                _this.closest(".category-data").find(".perc_budget_dollar_value").html(' $0.00');
            }

            if($(this).val()) {
                total_percentage +=  $(this).val()*1.0;
            }
        });

        container.find(".perc_unallocated").text("").text(abcsetup.accounting.formatNumber(100-total_percentage,2));
    },

    fieldError : () => {
        var errorField = $('form.manage-promotions').find('.invalid').first();

        if (!errorField.is(":visible")) {
            var promoPanelID = errorField.closest('.collapse').attr('id');
            // promoPanel.closest('.card').find('.card-header').trigger('click');
            $('div[data-target="#' + promoPanelID + '"]').trigger('click');
        }
    },
    /**
     * Validate the specified tab (null for all)
     */
    _validateForm: function ( init = false) {
        let dialog_html;
        let isValid = true;

        this.removeValidationAlerts();
        this.removeValidationOrnaments();

        // Find the current tab field we're validating
        const formDiv = $('form.manage-promotions');

        // Show the current form div to enable validation
        formDiv.find(':input:visible:not(:disabled)').each(function () {
            window.fieldValidate.runValidations(this);
            if (!this.validity.valid) {
                if (window.fieldValidate._debug) console.log('invalid:',this);
                isValid = false;
            }
        });

        // Build a validation message and update the left hand tabs
        if (isValid) {
            dialog_html = '<div class="form_validate_feedback_dialog alert alert-success">All fields on this page have passed validation</div>';
        } else if (!init) {
            dialog_html = '<div class="form_validate_feedback_dialog alert alert-danger">There are errors on this page. Please review the fields highlighted in red</div>';
        }

        // Add the validation message
        if (!init) {
            this.removeValidationAlerts({visible: true, invisible: true}, formDiv);
            formDiv.find('.title').after(dialog_html);
        }

        if (isValid && !init) {
            $(document).scrollTop(50);
        } else if (!isValid && !init) {
            var errorField = $('form.manage-promotions').find('.invalid').first();

            if (!errorField.is(":visible")) {
                var promoPanelID = errorField.closest('.collapse').attr('id');
                // promoPanel.closest('.card').find('.card-header').trigger('click');
                $('div[data-target="#' + promoPanelID + '"]').trigger('click');
            }

            // TODO We should be okay to remove this.
            $('.invalid:visible:first').trigger('focus');

            this.removeValidationOrnaments({visible: false});
            this.removeValidationAlerts({visible: false});

            if ($('.invalid:visible:first').hasClass("readonly")) {
                $('.invalid:visible:first').blur();
            }
        }

        return isValid;
    },

    removeValidationAlerts({invisible = true, visible = true} = {}, context) {
        context = context || document;

        if (visible) {
            $(context).find('.form_validate_feedback_dialog:visible').remove();
        }

        if (invisible) {
            $(context).find('.form_validate_feedback_dialog:not(:visible)').remove();
        }
    },

    removeValidationOrnaments({invisible = true, visible = true} = {}) {
        visible && window.fieldValidate.removeOrnaments($('.invalid:visible'));
        invisible && window.fieldValidate.removeOrnaments($('.invalid:not(:visible)'));
    },
}
